export default __webpack_public_path__ + "static/media/colorsw.aa382d1b.svg";